// Modules
import { produce } from 'immer'

// Constants
import { localStorageActiveTradeItemsKey } from 'constants/index'

import { getCurrencyCategoryByNameHelper } from 'hooks/useMarketWatchAccordionList'

// Types
import {
  ADD_ACTIVE_TRADE_ITEM,
  DELETE_ALL_TRADES,
  DELETE_TRADE_ITEM,
  SET_ACTIVE_TRADE_ITEM,
} from 'store/actions/ActiveTradeItems/types'

const initialState = {
  activeTradeItemsList: JSON.parse(localStorage.getItem(localStorageActiveTradeItemsKey)) || [],
  chosenActiveTradeItem:
    JSON.parse(localStorage.getItem(localStorageActiveTradeItemsKey))?.[0] || null,
}

const activeTradeItemsReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case ADD_ACTIVE_TRADE_ITEM: {
        const itemIdToAdd = action.payload
        const itemIndexToAdd = draft.activeTradeItemsList.findIndex(
          (item) => item?.id === itemIdToAdd?.id && item?.name === itemIdToAdd?.name,
        )

        if (itemIndexToAdd === -1) {
          draft.activeTradeItemsList.unshift(action.payload)
        }
        localStorage.setItem(
          localStorageActiveTradeItemsKey,
          JSON.stringify(draft.activeTradeItemsList),
        )
        break
      }
      case SET_ACTIVE_TRADE_ITEM:
        draft.chosenActiveTradeItem = action.payload
        break
      case DELETE_ALL_TRADES:
        draft.activeTradeItemsList = []
        draft.chosenActiveTradeItem = null
        localStorage.setItem(localStorageActiveTradeItemsKey, JSON.stringify([]))
        break
      case DELETE_TRADE_ITEM:
        draft.activeTradeItemsList = action.payload
        localStorage.setItem(localStorageActiveTradeItemsKey, JSON.stringify(action.payload))
        break
      default:
        break
    }
  })

export default activeTradeItemsReducer
